import React, { useState } from "react";
import api from "../../../api";
import {
  POKEBALL_ITEM_ID,
  GREATBALL_ITEM_ID,
  ULTRABALL_ITEM_ID,
  LONGBALL_ITEM_ID,
  RANGEBALL_ITEM_ID,
  MUDBALL_ITEM_ID,
  RUBYBALL_ITEM_ID,
  SAPPHIREBALL_ITEM_ID,
  EMERALDBALL_ITEM_ID,
  GOLDENBALL_ITEM_ID,
  DIAMONDBALL_ITEM_ID,
  SHADOWBALL_ITEM_ID,
  LURE_ITEM_ID,
  SUPER_LURE_ITEM_ID,
  ULTRA_LURE_ITEM_ID,
  DROP_POTION_ID,
  MINING_POTION,
  SHINY_POTION_ID,
  SCENT_GENGAR_ID,
  MINERAL_POTION_ID,
  pokeballImg,
  rubyGummyImg,
  sapphireGummyImg,
  emeraldGummyImg,
  goldenGummyImg,
  diamondGummyImg,
  greatballImg,
  ultraballImg,
  rangeballImg,
  longballImg,
  lureImg,
  superLureImg,
  ultraLureImg,
  mineLureImg,
  dropLureImg,
  mineralPotionImg,
  shinyPotionImg,
  scentofGengarImg,
  mudballImg,
  rubyballImg,
  sapphireballImg,
  emeraldballImg,
  goldenballImg,
  diamondballImg,
  shadowballImg,
  rawstberryImg,
  sitrusberryImg,
  razzberryImg,
  magostberryImg,
  aspearberryImg,
} from "../../../constants/items";

import sapphireImg from "../../../assets/images/items/sapphire.png";
import rubyImg     from "../../../assets/images/items/ruby.png";
import emeraldImg  from "../../../assets/images/items/emerald.png";
import goldImg     from "../../../assets/images/items/gold.png";
import diamondImg  from "../../../assets/images/items/diamond.png";
import rockImg     from "../../../assets/images/items/rock.png";

// Evolution stone image paths (using public folder)
const EVOLUTION_STONE_PATHS = {
  fire_stone: "/items/firestone.png",
  water_stone: "/items/waterstone.png",
  thunder_stone: "/items/thunderstone.png",
  leaf_stone: "/items/leafstone.png",
  moon_stone: "/items/moonstone.png",
  dawn_stone: "/items/dawnstone.png",
  metal_coat: "/items/metalcoat.png",
  kings_rock: "/items/kingsrock.png"
};

// IDs of gummies to include in items panel
const GUMMY_IDS = [6, 7, 8, 9, 10];

export default function InventoryPanel({
  inventory = [],
  gems = {},
  selectedAction,
  setSelectedAction,
  handleLureClick,
  resetRocks,
  spawnText,
  playerPos,
  onMineralPotionUse,
  activeLure = null, // Add activeLure prop to check which lures are active
}) {

  // State for confirmation modal
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [confirmationItem, setConfirmationItem] = useState(null);
  const [confirmationItemName, setConfirmationItemName] = useState("");
  
  // Show confirmation dialog for lures and potions
  const showItemConfirmation = (itemId, itemName) => {
    setConfirmationItem(itemId);
    setConfirmationItemName(itemName);
    setShowConfirmation(true);
  };

  // Handle confirmation dialog actions
  const handleConfirm = () => {
    if (!confirmationItem) return;
    
    if (confirmationItem === MINERAL_POTION_ID) {
      handleMineralPotionUse(confirmationItem);
    } else if ([LURE_ITEM_ID, SUPER_LURE_ITEM_ID, ULTRA_LURE_ITEM_ID, MINING_POTION, SHINY_POTION_ID, DROP_POTION_ID, SCENT_GENGAR_ID, 6, 7, 8, 9, 10].includes(confirmationItem) && handleLureClick) {
      handleLureClick(confirmationItem);
    }
    
    // Reset confirmation state
    setShowConfirmation(false);
    setConfirmationItem(null);
    setConfirmationItemName('');
  };

  const handleCancel = () => {
    setShowConfirmation(false);
    setConfirmationItem(null);
    setConfirmationItemName('');
  };

  const handleMineralPotionUse = async (itemId) => {
    try {
      const response = await api.post(
        "/v1/use_item",
        { item_id: itemId },
        { withCredentials: true }
      );

      if (response.data.success) {
        // Use spawnText instead of alert if available
        if (spawnText && playerPos) {
          spawnText("Mineral Potion activated! All rocks will be minerals for 2 minutes.", playerPos.x, playerPos.y - 32, "#7fffd4", "💎");
        }

        // Store the expiration time if provided
        if (response.data.expiration && onMineralPotionUse) {
          onMineralPotionUse(response.data.expiration);
        }

        setSelectedAction(null);
        if (resetRocks) {
          resetRocks();
        }
      } else {
        // Show error message as spawn text if available, otherwise fall back to alert
        if (spawnText && playerPos) {
          spawnText(response.data.message || "Failed to use Mineral Potion", playerPos.x, playerPos.y - 32, "#ff6b6b");
        } else {
          alert(response.data.message || "Failed to use Mineral Potion");
        }
      }
    } catch (error) {
      console.error("Error using Mineral Potion:", error);
    }
  };


  // Render a Poké-ball, potion, lure, or gummy item
  const renderItem = item => {
    const isBall = [
      POKEBALL_ITEM_ID,
      GREATBALL_ITEM_ID,
      ULTRABALL_ITEM_ID,
      LONGBALL_ITEM_ID,
      RANGEBALL_ITEM_ID,
      MUDBALL_ITEM_ID,
      RUBYBALL_ITEM_ID,
      SAPPHIREBALL_ITEM_ID,
      EMERALDBALL_ITEM_ID,
      GOLDENBALL_ITEM_ID,
      DIAMONDBALL_ITEM_ID,
      SHADOWBALL_ITEM_ID,
    ].includes(item.item);

    const isBerry = item.item === 199 || item.item === 200 || item.item === 201 || item.item === 202 || item.item === 203;

    const isSel =
      (isBall &&
        selectedAction?.type === "ball" &&
        selectedAction.payload.item === item.item) ||
      (isBerry &&
        selectedAction?.type === "berry" &&
        selectedAction.payload.item === item.item) ||
      (!isBall && !isBerry &&
        selectedAction?.type === "item" &&
        selectedAction.payload === item.item);

    let img, alt;
    switch (item.item) {
      case POKEBALL_ITEM_ID:       img = pokeballImg;      alt = "Pokéball";         break;
      case GREATBALL_ITEM_ID:      img = greatballImg;     alt = "Great Ball";      break;
      case ULTRABALL_ITEM_ID:      img = ultraballImg;     alt = "Ultra Ball";      break;
      case LONGBALL_ITEM_ID:       img = longballImg;      alt = "Long Ball";       break;
      case MUDBALL_ITEM_ID:        img = mudballImg;       alt = "Mud Ball";        break;
      case RUBYBALL_ITEM_ID:       img = rubyballImg;      alt = "Ruby Ball";       break;
      case SAPPHIREBALL_ITEM_ID:   img = sapphireballImg;  alt = "Sapphire Ball";   break;
      case EMERALDBALL_ITEM_ID:    img = emeraldballImg;   alt = "Emerald Ball";    break;
      case GOLDENBALL_ITEM_ID:     img = goldenballImg;    alt = "Golden Ball";     break;
      case DIAMONDBALL_ITEM_ID:    img = diamondballImg;   alt = "Diamond Ball";    break;
      case SHADOWBALL_ITEM_ID:    img = shadowballImg;   alt = "Shadow Ball";    break;
      case RANGEBALL_ITEM_ID:      img = rangeballImg;     alt = "Range Ball";      break;
      case LURE_ITEM_ID:           img = lureImg;          alt = "Lure";            break;
      case SUPER_LURE_ITEM_ID:     img = superLureImg;     alt = "Super Lure";      break;
      case ULTRA_LURE_ITEM_ID:     img = ultraLureImg;     alt = "Ultra Lure";      break;
      case MINING_POTION:          img = mineLureImg;      alt = "Mining Potion";   break;
      case DROP_POTION_ID:         img = dropLureImg;      alt = "Drop Potion";     break;
      case MINERAL_POTION_ID:      img = mineralPotionImg; alt = "Mineral Potion";  break;
      case SHINY_POTION_ID:        img = shinyPotionImg;   alt = "Shiny Potion";    break;
      case SCENT_GENGAR_ID:        img = scentofGengarImg;   alt = "Scent of Gengar";    break;
      case 6:                      img = rubyGummyImg;     alt = "Ruby Gummy";      break;
      case 7:                      img = sapphireGummyImg; alt = "Sapphire Gummy";  break;
      case 8:                      img = emeraldGummyImg;  alt = "Emerald Gummy";   break;
      case 9:                      img = goldenGummyImg;   alt = "Golden Gummy";    break;
      case 10:                     img = diamondGummyImg;  alt = "Diamond Gummy";   break;
      case 199:                    img = rawstberryImg;    alt = "Rawstberry";    break;
      case 200:                    img = sitrusberryImg;    alt = "Sitrusberry";    break;
      case 201:                    img = aspearberryImg;    alt = "Aspearberry";    break;
      case 202:                    img = magostberryImg;    alt = "Magostberry";    break;
      case 203:                    img = razzberryImg;    alt = "Razzberry";    break;
      default:                     img = pokeballImg;      alt = "Item";
    }

    // Check if any lure is active and this is a different lure
    const isLure = [LURE_ITEM_ID, SUPER_LURE_ITEM_ID, ULTRA_LURE_ITEM_ID].includes(item.item);
    const isOtherLureActive = 
      isLure && 
      activeLure && 
      !((item.item === LURE_ITEM_ID && activeLure === "lure") ||
        (item.item === SUPER_LURE_ITEM_ID && activeLure === "super_lure") ||
        (item.item === ULTRA_LURE_ITEM_ID && activeLure === "ultra_lure"));
    
    // Disable other lures when one is active
    const isDisabled = isOtherLureActive;
    
    const onClick = (e) => {
      // Stop event propagation to prevent togglePouch from being called
      e.stopPropagation();
      
      // Don't do anything if item is disabled
      if (isDisabled) return;
      
      if (isBall) {
        localStorage.setItem("selectedBall", item.item.toString());
        setSelectedAction({ type: "ball", payload: item });
      } else if (isBerry) {
        // Berry - treat like pokeball, no confirmation
        localStorage.setItem("selectedBerry", item.item.toString());
        setSelectedAction({ type: "berry", payload: item });
      } else if (item.item === MINERAL_POTION_ID || 
                [LURE_ITEM_ID, SUPER_LURE_ITEM_ID, ULTRA_LURE_ITEM_ID, MINING_POTION, SHINY_POTION_ID, DROP_POTION_ID, 6, 7, 8, 9, 10, SCENT_GENGAR_ID].includes(item.item)) {
        // Show confirmation for potions and lures
        showItemConfirmation(item.item, alt);
        console.log("Showing confirmation for", alt); // Debug log
      } else {
        localStorage.setItem("selectedRock", item.item.toString());
        setSelectedAction({ type: "item", payload: item.item });
      }
    };

    return (
      <div
        key={item.item}
        onClick={onClick}
        style={{
          width: 28,
          height: 28,
          margin: 3,
          position: "relative",
          cursor: isDisabled ? "not-allowed" : "pointer",
          borderRadius: 6,
          background: isDisabled ? "rgba(75, 75, 75, 0.3)" : 
                     isSel ? "rgba(255, 224, 102, 0.2)" : "rgba(255, 255, 255, 0.1)",
          border: isSel ? "2px solid #ffe066" : "2px solid transparent",
          padding: 3,
          transition: "all 0.2s ease",
          boxShadow: isSel ? "0 0 12px rgba(255, 224, 102, 0.4)" : "0 2px 4px rgba(0,0,0,0.2)",
          transform: isSel ? "scale(1.05)" : "scale(1)",
          opacity: isDisabled ? 0.5 : 1
        }}
        onMouseEnter={(e) => {
          if (!isSel) {
            e.target.style.background = "rgba(255, 255, 255, 0.15)";
            e.target.style.transform = "scale(1.02)";
          }
        }}
        onMouseLeave={(e) => {
          if (!isSel) {
            e.target.style.background = "rgba(255, 255, 255, 0.1)";
            e.target.style.transform = "scale(1)";
          }
        }}
      >
        <img
          src={img}
          alt={alt}
          style={{ 
            width: "100%", 
            height: "100%", 
            objectFit: "contain",
            filter: isDisabled ? "grayscale(1) brightness(0.8)" : 
                   isSel ? "brightness(1.1)" : "brightness(1)"
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: -2,
            right: -2,
            background: "linear-gradient(135deg, #4a5568, #2d3748)",
            borderRadius: 4,
            padding: "1px 3px",
            fontSize: 8,
            fontWeight: "600",
            zIndex: 10,
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.2)",
            boxShadow: "0 1px 2px rgba(0,0,0,0.3)",
            minWidth: 12,
            textAlign: "center",
            lineHeight: 1
          }}
        >
          {item.amount}
        </div>
      </div>
    );
  };

  // Render a gem (rock, sapphire, etc.) - separate gem currency
  const renderGem = ([name, amount]) => {
    // Make sure we use the correct image for each mineral type
    let icon;
    
    // Check if it's an evolution stone
    if (EVOLUTION_STONE_PATHS[name]) {
      // Use the public path for evolution stones
      icon = EVOLUTION_STONE_PATHS[name];
    } else {
      // Use imported images for basic minerals
      switch (name) {
        case "ruby": icon = rubyImg; break;
        case "sapphire": icon = sapphireImg; break;
        case "emerald": icon = emeraldImg; break;
        case "gold": icon = goldImg; break;
        case "diamond": icon = diamondImg; break;
        case "rock": icon = rockImg; break;
        // For any other items, use rock image as fallback
        default: icon = rockImg;
      }
    }
    
    const isSel = selectedAction?.type === "item" && selectedAction.payload === name;

    const onClick = (e) => {
      // Stop event propagation to prevent togglePouch from being called
      e.stopPropagation();
      setSelectedAction({ type: "item", payload: name });
    };

    return (
      <div
        key={name}
        onClick={onClick}
        style={{
          width: 28,
          height: 28,
          margin: 3,
          position: "relative",
          cursor: "pointer",
          borderRadius: 6,
          background: isSel ? "rgba(76, 175, 80, 0.2)" : "rgba(255, 255, 255, 0.1)",
          border: isSel ? "2px solid #4caf50" : "2px solid transparent",
          padding: 3,
          transition: "all 0.2s ease",
          boxShadow: isSel ? "0 0 12px rgba(76, 175, 80, 0.4)" : "0 2px 4px rgba(0,0,0,0.2)",
          transform: isSel ? "scale(1.05)" : "scale(1)"
        }}
        onMouseEnter={(e) => {
          if (!isSel) {
            e.target.style.background = "rgba(255, 255, 255, 0.15)";
            e.target.style.transform = "scale(1.02)";
          }
        }}
        onMouseLeave={(e) => {
          if (!isSel) {
            e.target.style.background = "rgba(255, 255, 255, 0.1)";
            e.target.style.transform = "scale(1)";
          }
        }}
      >
        <img
          src={icon}
          alt={name}
          style={{ 
            width: "100%", 
            height: "100%", 
            objectFit: "contain",
            filter: isSel ? "brightness(1.1)" : "brightness(1)"
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: -2,
            right: -2,
            background: "linear-gradient(135deg, #4a5568, #2d3748)",
            borderRadius: 4,
            padding: "1px 3px",
            fontSize: 8,
            fontWeight: "600",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.2)",
            boxShadow: "0 1px 2px rgba(0,0,0,0.3)",
            minWidth: 12,
            textAlign: "center",
            lineHeight: 1
          }}
        >
          {amount}
        </div>
      </div>
    );
  };

  // Split inventory into categories
  const pokeballs = inventory.filter(i =>
    [POKEBALL_ITEM_ID, GREATBALL_ITEM_ID, ULTRABALL_ITEM_ID, LONGBALL_ITEM_ID, RANGEBALL_ITEM_ID, MUDBALL_ITEM_ID, RUBYBALL_ITEM_ID, SAPPHIREBALL_ITEM_ID, EMERALDBALL_ITEM_ID, GOLDENBALL_ITEM_ID, DIAMONDBALL_ITEM_ID, SHADOWBALL_ITEM_ID]
      .includes(i.item)
  );
  const lures = inventory.filter(i =>
    [LURE_ITEM_ID, SUPER_LURE_ITEM_ID, ULTRA_LURE_ITEM_ID].includes(i.item)
  );
  const potions = inventory.filter(i =>
    [MINING_POTION, DROP_POTION_ID, MINERAL_POTION_ID,SHINY_POTION_ID,SCENT_GENGAR_ID ].includes(i.item)
  );
  const gummies = inventory.filter(i => GUMMY_IDS.includes(i.item));
  const berries = inventory.filter(i =>
    [199,200,201,202,203 ].includes(i.item)
  );
  const orderedItems = [...pokeballs, ...lures, ...potions, ...gummies, ...berries];

  return (
    <>
      {/* Confirmation Modal */}
      {showConfirmation && (
        <>
          {/* Semi-transparent overlay - only close modal when clicking it, not the entire inventory */}
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 2000,
              pointerEvents: "all"
            }}
            onClick={(e) => {
              e.stopPropagation(); // Prevent closing the inventory
              handleCancel();
            }}
          />
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "220px",
              background: "linear-gradient(145deg, #2d3748, #1a202c)",
              borderRadius: "8px",
              padding: "16px",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.5)",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              zIndex: 2001,
              color: "#fff",
              textAlign: "center"
            }}
          >
          <h3 style={{ margin: "0 0 10px 0", fontSize: "15px", color: "#ffd700" }}>
            Confirm Use
          </h3>
          <p style={{ margin: "0 0 12px 0", color: "#cbd5e0", fontSize: "13px" }}>
            Are you sure you want to use {confirmationItemName}?
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <button
              onClick={(e) => {
                e.stopPropagation(); // Prevent closing the inventory
                handleCancel();
              }}
              style={{
                background: "linear-gradient(to bottom, #4a5568, #2d3748)",
                color: "#fff",
                border: "1px solid #1a202c",
                padding: "6px 12px",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "12px",
                fontWeight: "500",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.3)",
                transition: "all 0.2s ease",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.background = "linear-gradient(to bottom, #4a5568, #3a4556)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.background = "linear-gradient(to bottom, #4a5568, #2d3748)";
              }}
            >
              Cancel
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation(); // Prevent closing the inventory
                handleConfirm();
              }}
              style={{
                background: "linear-gradient(135deg, #667eea, #764ba2)",
                color: "#fff",
                border: "1px solid #4c366b",
                padding: "6px 12px",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "12px",
                fontWeight: "500",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.3)",
                transition: "all 0.2s ease",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.background = "linear-gradient(135deg, #7a8eee, #8659b5)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.background = "linear-gradient(135deg, #667eea, #764ba2)";
              }}
            >
              Use Item
            </button>
          </div>
          </div>
        </>
      )}
      <div
        className="inventory-panel"
        style={{
        width: 160,
        minWidth: 160,
        maxHeight: "280px",
        background: "linear-gradient(145deg, rgba(26, 32, 44, 0.95), rgba(45, 55, 72, 0.95))",
        color: "#fff",
        padding: 8,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        borderRadius: 6,
        backdropFilter: "blur(12px)",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        boxShadow: "0 4px 16px rgba(0, 0, 0, 0.3)",
        overflow: "hidden",
        zIndex: 1000
      }}
    >
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        marginBottom: 8,
        width: "100%",
        borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
        paddingBottom: 6,
        flexShrink: 0
      }}>
        <div style={{
          width: 3,
          height: 12,
          background: "linear-gradient(135deg, #667eea, #764ba2)",
          borderRadius: 2
        }} />
        <h4 style={{ 
          margin: 0, 
          fontSize: 12, 
          fontWeight: "600",
          letterSpacing: "0.5px",
          textTransform: "uppercase"
        }}>Items</h4>
      </div>
      <div style={{ 
        display: "flex", 
        flexWrap: "wrap",
        gap: 2,
        marginBottom: 8,
        width: "100%",
        maxHeight: "80px",
        overflowY: "auto",
        overflowX: "hidden",
        paddingRight: 4
      }}>
        {orderedItems.map(renderItem)}
      </div>

      <div style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        marginBottom: 8,
        width: "100%",
        borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
        paddingBottom: 6,
        flexShrink: 0
      }}>
        <div style={{
          width: 3,
          height: 12,
          background: "linear-gradient(135deg, #4caf50, #45a049)",
          borderRadius: 2
        }} />
        <h4 style={{ 
          margin: 0, 
          fontSize: 12, 
          fontWeight: "600",
          letterSpacing: "0.5px",
          textTransform: "uppercase"
        }}>Minerals</h4>
      </div>
      <div style={{ 
        display: "flex", 
        flexWrap: "wrap",
        gap: 2,
        width: "100%",
        maxHeight: "60px",
        overflowY: "auto",
        overflowX: "hidden",
        paddingRight: 4
      }}>
        {Object.entries(gems).map(renderGem)}
      </div>
    </div>
    </>
  );
}
